export const enCa: { [key: string]: string } = {
  icon_language: 'language',
  icon_login: 'person_add',
  icon_logout: 'exit_to_app',
  icon_user: 'person',
  icon_user_guest: 'person_outline',

  card_exist_msg_1: 'oops, this card already exists with Balance $',
  card_exist_msg_2:
    '.  Would you like to add to this card or purchase a new card?',
  min_qty_error: 'Please enter Qty greater than 1 and also enter card number',

  item_label: 'Item: ',
  price_label: 'Price: ',

  btn_auto_generate: 'Auto Generate Gift Card Number',
  btn_new_gift_card: 'New Gift Card',
  btn_add_to_card: 'Add To Card',
  btn_done: 'Done',
  btn_cancel: 'Cancel',
  btn_apply_discount: 'Apply Discount',

  cancel_trns_msg:
    'Are you sure you want to cancel the transaction? Doing this will remove all the added items.',
  trns_completed_msg: 'Transaction Completed',
  no_not_found_msg: 'Number not found. Please try again',

  discount_title: 'Enter discount cash/percent',

  item_removed_fav: 'Item removed from favorite tab',
  item_added_fav: 'Item added to favorite tab',
  returnable_items: 'Returnable Items For Transaction ID - ',
  delete: 'Are you sure you want to delete this record?',
  note_delete_successful: 'Record deleted successfully'
};
